import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import ClearIcon from "@material-ui/icons/Clear";
import { IconButton } from "@material-ui/core";
import { withTheme } from 'styled-components';


const CssTextField = withStyles({
  root: {
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: 0,
    },
    '& .MuiInputLabel-formControl': {
      top: '-2px',
    },
    '& label.Mui-focused': {
      color: '#528b46',
    },
    '& .MuiInput-underline:after': {
      borderColor: '#528b46',
      borderRadius: '1'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: '#528b46',
        borderRadius: '1',
        color: 'white'
      },
      '&:hover fieldset': {
        borderColor: '#528b46',
        borderRadius: '1',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#528b46',
        borderRadius: '1'
      },
      height: '30px',
      // fontSize: '80'
      color: 'white',
    },

  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    // color: 'white'
  },
  margin: {
    marginRight: '6px',
    marginBottom: '10px',
  },
}));

export default function CustomizedInputs(props) {
  const classes = useStyles();

  return (
    <>
      {/* <div class="date"> */}
      {/* <input type="date" /> */}
      {/* </div> */}
      <CssTextField
        className={classes.margin}
        label={props.label}
        variant={props.variant}
        id={props.id}
        size={props.size}
        name={props.name}
        autoFocus={false}
        inputProps={{
          style: { fontSize: 20 },
          maxLength: props.maxLength,
          pattern: props.pattern,

          // fontSize: 40

        }}
        // InputProps={{
        //   endAdornment: (
        //     <label>Segunda</label>
        //   )
        // }}
        InputLabelProps={{
          shrink: true
        }}
        {...props}
        // type="date"
        type={(props.time === 'S') ? "datetime-local" : "date"}
      />
    </>
  );
}